var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3034_16305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3034_16305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0533 12L15.1264 7.92689C15.2649 7.78844 15.3357 7.6144 15.3389 7.40479C15.3421 7.19519 15.2713 7.01795 15.1264 6.87309C14.9816 6.7282 14.8059 6.65576 14.5995 6.65576C14.3931 6.65576 14.2175 6.7282 14.0726 6.87309L9.5784 11.3673C9.4848 11.4609 9.41877 11.5596 9.38032 11.6635C9.34186 11.7673 9.32262 11.8795 9.32262 12C9.32262 12.1205 9.34186 12.2327 9.38032 12.3365C9.41877 12.4404 9.4848 12.5391 9.5784 12.6327L14.0726 17.1269C14.2111 17.2654 14.3851 17.3362 14.5947 17.3394C14.8043 17.3426 14.9816 17.2718 15.1264 17.1269C15.2713 16.982 15.3438 16.8064 15.3438 16.6C15.3438 16.3936 15.2713 16.218 15.1264 16.0731L11.0533 12Z",
    fill: "#DE841B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftColored);
export default __webpack_public_path__ + "static/media/chevron_left_colored.47e6c98844f9c05dc65f5f36a710eef8.svg";
export { ForwardRef as ReactComponent };